// @flow
import React from 'react';
import Slot from 'shared/editor/Slot';
import withThemeProvider from 'shared/hoc/withThemeProvider';
import type { $Slot } from '../../../types';

type Props = {
  slots: $Slot[],
  widgetPresets: Array<Object>,
  path: string
}

/**
 * A clean canvas: one full-width area for sections, with no menu bar, footer, heading, background or
 * starter widgets. For pages built from a design (AI sections) or from scratch, instead of starting
 * from Homepage and deleting its widgets. The menu bar and footer areas start empty and render nothing;
 * a header or footer can still be added to them in the editor.
 */
function Blank(props: Props) {
  const { slots, widgetPresets, path } = props;

  return (
    <div>
      {/* Above the content, so the menu's dropdowns open over it. */}
      <div style={{ width: '100%', position: 'relative', zIndex: 10 }}>
        <Slot id="menu-bar" slots={slots} widgetPresets={widgetPresets} path={path} />
      </div>
      <div style={{ width: '100%', position: 'relative' }}>
        <Slot id="content" slots={slots} widgetPresets={widgetPresets} path={path} />
      </div>
      <div style={{ width: '100%' }}>
        <Slot id="footer" slots={slots} widgetPresets={widgetPresets} path={path} />
      </div>
    </div>
  );
}

// https://github.com/webpack/webpack/issues/706
export default withThemeProvider(Blank);
